module.exports = __webpack_public_path__ + "img/portfolio11.e9e63251.jpg";